import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class BusinessHeadCenterService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(adminId, data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.BUSINESS_HEAD_CENTERS(adminId), data);
    }

    /*getHeadCenterAdmin(head_center_id): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_HEAD_CENTER_ADMIN(head_center_id));
    }*/

    count(): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_HEAD_CENTERS_COUNT());
    }

    detail(adminId, id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.BUSINESS_HEAD_CENTER_DETAIL(adminId, id));
    }

    detailById(id): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_HEAD_CENTER_DETAIL_BY_ID(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.BUSINESS_HEAD_CENTERS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_HEAD_CENTERS(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_HEAD_CENTER_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_HEAD_CENTER_STATUS(id), data);
    }

    /*updateUniqueLinkStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLOR_UNIQUE_LINK_STATUS(id), data);
    }

    headCounsellorUniversity(id, data): Observable<any> {
        return this.putRequest(AppUrl.HEAD_COUNSELLOR_UNIVERSITY(id), data);
    }

    getCounsellorUniversities(id, data): Observable<any> {
        return this.getRequest(AppUrl.HEAD_COUNSELLOR_UNIVERSITY(id), data);
    }*/

    /*updateProfile(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_HEAD_CENTER_PROFILE_IMAGE(id), data);
    }

    getHeadCounsellorReportCount(id): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_HEAD_CENTERS_PROGRESS_REPORT_COUNT(id));
    }

    getBusinessHeadCenters(id, data): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_HEAD_CENTERS_COUNSELLORS(id), data);
    }*/
}
